import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ApiService } from "app/api.service";

@Component({
  selector: "app-questionnaire",
  templateUrl: "./questionnaire.component.html",
  styleUrls: ["./questionnaire.component.scss"]
})
export class QuestionnaireComponent implements OnInit {
  currentState = 0;
  resultsLoaded = false;
  showResults = false;
  // InitQuestionnaire
  state = "start";
  states = [
    "present",
    "future",
    "future",
    "future",
    "future",
    "future",
    "future",
    "future",
    "future"
  ];
  ages = ["40-45", "46-50", "51-55", "56-up"];
  dailies = ["home", "office", "inside", "outside"];
  pals = ["first", "second", "experienced"];
  drives = ["rarely", "weekly", "several", "daily"];
  readings = ["less", "up", "multiple"];
  describesList = ["calm", "bit", "active"];

  questionnaire = {
    age: this.ages[0],
    gender: "male",
    dailyEnvironment: "home",
    pal: "first",
    drive: "rarely",
    reading: "less",
    describes: "calm",
    result: "",
    lang: ""
  };

  constructor(
    private apiService: ApiService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    // this.apiService.cretateLifeStyle(this.questionnaire);
  }

  setState(forward) {
    if (forward) {
      this.states[this.currentState] = "past";
      this.states[this.currentState + 1] = "present";
      this.currentState += 1;
    } else {
      this.states[this.currentState] = "future";
      this.states[this.currentState - 1] = "present";
      this.currentState -= 1;
    }
  }

  setAge(age) {
    this.questionnaire.age = age;
    setTimeout(() => this.setState(true), 500);
  }

  setGender(gender) {
    this.questionnaire.gender = gender;
    setTimeout(() => this.setState(true), 500);
  }

  setDaily(daily) {
    this.questionnaire.dailyEnvironment = daily;
    setTimeout(() => this.setState(true), 500);
  }

  setPal(pal) {
    this.questionnaire.pal = pal;
    setTimeout(() => this.setState(true), 500);
  }

  setDrive(drive) {
    this.questionnaire.drive = drive;
    setTimeout(() => this.setState(true), 500);
  }

  setReading(reading) {
    this.questionnaire.reading = reading;
    setTimeout(() => this.setState(true), 500);
  }

  setDescribes(describes) {
    this.questionnaire.describes = describes;
    setTimeout(() => this.setState(true), 500);
  }

  dailyResult() {
    switch (this.questionnaire.dailyEnvironment) {
      case "home": {
        return 1;
      }
      case "office": {
        return 1;
      }
      case "inside": {
        return 5;
      }
      case "outside": {
        return 10;
      }
    }
  }

  showLoader() {
    this.showResults = true;
    setTimeout(() => {
      this.questionnaire.result = this.loadResult();
      this.questionnaire.lang = this.translate.currentLang;
      this.apiService.cretateLifeStyle(this.questionnaire);
      this.resultsLoaded = true;
    }, 3000);
  }

  palResult() {
    switch (this.questionnaire.pal) {
      case "first": {
        return 10;
      }
      case "second": {
        return 5;
      }
      case "experienced": {
        return 5;
      }
    }
  }

  driveResult() {
    switch (this.questionnaire.drive) {
      case "daily": {
        return 10;
      }
      case "several": {
        return 7;
      }
      case "weekly": {
        return 3;
      }
      case "rarely": {
        return 1;
      }
    }
  }

  readingResult() {
    switch (this.questionnaire.reading) {
      case "less": {
        return 10;
      }
      case "up": {
        return 5;
      }
      case "multiple": {
        return 1;
      }
    }
  }

  describesResult() {
    switch (this.questionnaire.describes) {
      case "calm": {
        return 5;
      }
      case "bit": {
        return 1;
      }
      case "active": {
        return 10;
      }
    }
  }

  loadResult() {
    const result =
      this.dailyResult() +
      this.palResult() +
      this.driveResult() +
      this.readingResult() +
      this.describesResult();
    // console.log("result" + result);
    if (result < 20) {
      return "indoor";
    } else if (result < 30) {
      return "urban";
    } else {
      return "outdoor";
    }
  }

  reload() {
    window.location.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/questionnaire/questionnaire.component.ts